import React from "react";
import { useSelector } from "react-redux";
import Icon from "../../../ui/icons/Icon";
import iconsList from "../../../ui/icons/iconsList";
import classes from './CleanSearch.module.css'

const CleanSearch = ({ setFilters, onSearchClick }) => {

    const { texts } = useSelector(state => state.translate);

    const cleanSearchHandle = () => {
        setFilters && setFilters(null)
        onSearchClick && onSearchClick()
    }

    return (
        <button className={classes.CleanSearch} onClick={() => cleanSearchHandle()}>
            <Icon name={iconsList.refresh} size="17px" height="unset" className={classes.Icon} />
            <p className={classes.CleanSearchText}>{texts.cleanSearch}</p>
        </button>
    )
}

export default CleanSearch;